<template>
  <v-app>
    <v-main>
      <div class="register-page">
        <div class="sidebar register-page-sidebar">
          <div class="d-flex flex-column align-center justify-center" style="width: 320px; z-index:1;">
            <img src="/image/logo-white.png" alt="onlinemed logo brand" class="register-page-img py-0 px-16">
            <p class="white--text text-center mt-4" style="opacity: 0.8">Sog'liqni saqlash xizmatlari — bir tugma
              bilan</p>
            <div class=" mt-10 justify-center align-center" style="opacity: 1; transform: none; gap: 16px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr))">
              <div
                  class="afzallik"
                  style="opacity: 1; transform: none;">
                <div class="afzallik-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="lucide lucide-shield w-4 h-4 text-white">
                    <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  </svg>
                </div>
                <span class="afzallik-text">Xavfsiz platforma</span></div>
              <div
                  class="afzallik"
                  style="opacity: 1; transform: none;">
                <div class="afzallik-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="lucide lucide-heart w-4 h-4 text-white">
                    <path
                        d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                  </svg>
                </div>
                <span class="afzallik-text">Sog'liqni saqlash</span></div>
              <div
                  class="afzallik"
                  style="opacity: 1; transform: none;">
                <div class="afzallik-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="lucide lucide-activity w-4 h-4 text-white">
                    <path
                        d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"></path>
                  </svg>
                </div>
                <span class="afzallik-text">Tezkor xizmat</span></div>
            </div>
          </div>
          <div class="position-absolute" style="opacity: 1; width: 50%; height: 100%; top: 0; left: 0; z-index: 0">
            <div class="position-absolute text-white-06 text-6xl font-bold select-none"
                 style="top: 15%; left: 10%; transform: translateY(-10.5491px) rotate(5.27454deg);">+
            </div>
            <div class="position-absolute text-white-06 text-6xl font-bold select-none"
                 style="top: 30%; left: 40%; transform: translateY(-0.563697px) rotate(0.281849deg);">+
            </div>
            <div class="position-absolute text-white-06 text-6xl font-bold select-none"
                 style="top: 45%; left: 70%; transform: translateY(-14.2085px) rotate(7.10423deg);">+
            </div>
            <div class="position-absolute text-white-06 text-6xl font-bold select-none"
                 style="top: 60%; left: 10%; transform: translateY(-7.0161px) rotate(3.50805deg);">+
            </div>
            <div class="position-absolute text-white-06 text-6xl font-bold select-none"
                 style="top: 75%; left: 40%; transform: translateY(-13.7062px) rotate(6.85309deg);">+
            </div>
            <div class="position-absolute text-white-06 text-6xl font-bold select-none"
                 style="top: 90%; left: 70%; transform: translateY(-3.69745px) rotate(1.84873deg);">+
            </div>
            <div class="position-absolute w-64 h-64 rounded-full bg-white/[0.05] blur-3xl"
                 style="top: 10%; right: -10%; transform: scale(1.29993);"></div>
            <div class="position-absolute w-48 h-48 rounded-full bg-white/[0.05] blur-3xl"
                 style="bottom: 15%; left: -5%; transform: scale(1.13761);"></div>
          </div>
        </div>
        <slot></slot>
      </div>
    </v-main>

  </v-app>

</template>

<script>
export default {
  name: "LayoutRegister",

}
</script>

<style scoped>
.register-page-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh !important;
}

.register-page-img {
  max-width: 100%; /* never overflow container */
  object-fit: contain;
}

@media (max-width: 1200px) {
  .register-page-sidebar {
    display: none;
  }
}

.position-absolute {
  position: absolute;
}

.text-white-06 {
  color: rgba(255, 255, 255, 0.1);
  font-size: 60px;
  font-weight: 700;
}

.afzallik{
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px;
  align-items: center;
   background-color: rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  transition: 300ms;
}
.afzallik:hover{
  background-color: rgba(255, 255, 255, 0.2)!important;
}

.afzallik-icon{
  width: 36px;
  height: 36px;
  border-radius: 12px;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
}
.afzallik-icon svg{
  color: white;
  height: 16px;
  aspect-ratio: 1;
}
.afzallik-text{
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  line-height: 1;
}

</style>
